import { Age, Cefr } from "../constants";
import { IContentTag } from "./content-tags.model";

export const VALID_OWNER_TYPES = ['system', 'accounts', 'units', 'users'] as const;
export type OwnerType = typeof VALID_OWNER_TYPES[number];
export const VALID_PROGRAM_DURATIONS = ['Short', 'Medium', 'Long'];
export type ProgramDuration = typeof VALID_PROGRAM_DURATIONS[number];

export interface ILessonProgram {
	uid: string;
	name: string;
	ownerType: OwnerType;
	ownerId: string;
	description: string;
	image: string;
	targetCefr: Cefr;
	targetAgeRange: Age;
	lessons: string[];
	tagIds: string[];
	tags: IContentTag[];
	isPublished: boolean;
	duration?: ProgramDuration;
}
export interface ICreateLessonProgramBody {
	name: string;
	ownerType: OwnerType;
	ownerId: string;
	description: string;
	image: string;
	targetCefr: Cefr;
	targetAgeRange: Age;
	lessons: string[];
	tagIds: string[];
	tags: IContentTag[];
	isPublished: boolean;
	duration?: ProgramDuration;
}

